'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _dld_qrcode = require('./images/dld_qrcode.png');

var _dld_qrcode2 = _interopRequireDefault(_dld_qrcode);

var _wechat_qrcode_bottom = require('./images/wechat_qrcode_bottom02.png');

var _wechat_qrcode_bottom2 = _interopRequireDefault(_wechat_qrcode_bottom);

var _icons = require('./images/icons.png');

var _icons2 = _interopRequireDefault(_icons);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

var _wechat_pay2x = require('./images/wechat_pay@2x.png');

var _wechat_pay2x2 = _interopRequireDefault(_wechat_pay2x);

var _paypal_pay2x = require('./images/paypal_pay@2x.png');

var _paypal_pay2x2 = _interopRequireDefault(_paypal_pay2x);

require('./PCBasicIntro.css');

var _check = require('./images/check.png');

var _check2 = _interopRequireDefault(_check);

var _vip_user2x = require('./images/vip_user@2x.png');

var _vip_user2x2 = _interopRequireDefault(_vip_user2x);

require('regenerator-runtime/runtime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var WebBaseIntro = function (_React$Component) {
    _inherits(WebBaseIntro, _React$Component);

    function WebBaseIntro() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, WebBaseIntro);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WebBaseIntro.__proto__ || Object.getPrototypeOf(WebBaseIntro)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            downloadHost: 'https://download.xdiarys.com',
            downloadFileName: '/windows/xdiarys-setup-v3.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,

            showDownload: false,
            showPay: false,
            isVip: false,

            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com',

            threeMonthPayAmount: 28,
            oneYearPayAmount: 68,
            threeYearPayAmount: 148,

            paymentMethod: '',
            radioChecked: 3,
            showQR: false,

            wechatpayimage: '',
            wechatPayShow: false,
            wechatPayAmount: 0,

            tn: ''
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(WebBaseIntro, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            var search = new URLSearchParams(location.search);
            this.procPayInfo = this.procPayInfo.bind(this);
            this.procPay = this.procPay.bind(this);

            var inweb = search.get("inweb");
            if (inweb != null && inweb == 1) {
                this.setState({ payInWeb: true });
            }

            // 看有没有token，种cookie
            var token = search.get("token");

            if (token && token.length > 0) {
                token = decodeURIComponent(token, true);
                var cookie = _base2["default"].decode(token);
                var arrCookie = cookie.split(";");

                if (arrCookie.length > 0) {
                    this.clearAllCookie();
                }

                for (var i = 0; i < arrCookie.length; i++) {
                    var arr = arrCookie[i].split("=");
                    var key = arr[0];
                    var value = arr[1];

                    if (key && value) {
                        this.setCookie(key, value);
                    }
                }
            }

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }

            var oldUserName = this.getCookieValue('dcufnm');
            var newUserName = oldUserName;
            do {
                oldUserName = newUserName;
                newUserName = decodeURIComponent(oldUserName, true);
            } while (newUserName != oldUserName);

            this.setState({ pay_user: newUserName });

            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);

            var paramTN = search.get("tn");
            if (null != paramTN && paramTN.length > 0) {
                this.setState({ tn: paramTN, downloadFileName: '/xdiarys_' + paramTN + '.exe' });
            }

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('www_title');

            var lang = local.getLang();
            if (lang === 'chs') {

                this.GetContantUs();
                this.setState({ showBeianText: true, showHelp: true, downloadHost: 'https://download.xdiarys.com' });
            }

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });

            // 获取参数

            var paramRcmd = search.get("rcmd");
            var login = search.get("login");

            this.setState({ paramTN: paramTN, paramRcmd: paramRcmd });

            // 获取超时时间
            var paramExpTime = search.get("exptime");
            if (paramExpTime && paramExpTime.length > 0) {
                var timestamp = Date.parse(paramExpTime);
                var curTimestamp = Date.parse(new Date());
                var diffDay = (timestamp - curTimestamp) / (1000 * 60 * 60 * 24);
                diffDay = Math.floor(diffDay);

                if (diffDay > 0 && diffDay <= 30) {
                    this.setState({ expTime: paramExpTime, showExpTime: true });
                }
            }

            if (login == '1') {

                this.listenPay();

                var url = '';
                if (_Locale2["default"].GetInstance().getLocal() == 'zh') {
                    url = '/api/pay/list/wechat/web';
                    this.setState({ paymentMethod: 'wechat' });
                } else {
                    url = '/api/pay/list/paypal/web';
                    this.setState({ paymentMethod: 'paypal', threeMonthPayAmount: 4, oneYearPayAmount: 10, threeYearPayAmount: 21 });
                }

                // tab名称
                var titleText = _Locale2["default"].GetInstance().getMessagebyId('pay_title');
                document.title = titleText;

                fetch(url, {
                    method: "GET",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json, text/plain, */*'
                    }
                }).then(function (res) {
                    return res.json();
                }).then(function (res) {
                    _this3.procPayInfo(res);
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var search, login, response, retObj, vData, src;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                search = new URLSearchParams(location.search);
                                login = search.get("login");

                                if (!(login == '1')) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.prev = 3;
                                _context.next = 6;
                                return fetch('/api/users/account/info', {
                                    method: 'GET',
                                    credentials: 'include',
                                    headers: {
                                        'Accept': 'application/json, text/plain, */*'
                                    }
                                });

                            case 6:
                                response = _context.sent;
                                _context.next = 9;
                                return response.json();

                            case 9:
                                retObj = _context.sent;


                                if (retObj.result === 1) {
                                    vData = retObj.vdata;

                                    this.setState({ isVip: vData.vip || false });
                                }
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](3);

                                console.error('Error fetching account info:', _context.t0);

                            case 16:

                                // 更新showPay和showDownload状态
                                src = search.get("src");

                                if (src === 'web') {
                                    this.setState({ showPay: false, showDownload: true });
                                } else if ((src === 'macos' || src === 'windows') && this.state.tn != '360ly' && this.state.tn != 'lenovoly') {
                                    if (login == '0') {
                                        this.setState({ showPay: false, showDownload: false });
                                    } else if (login == '1') {
                                        this.setState({ showPay: true, showDownload: false });
                                    }
                                }

                                /*if(this.state.isVip == false){
                                    this.setState({showPay: true, showDownload: false});
                                }else if(this.state.isVip == true){
                                    this.setState({showPay: true, showDownload: false});
                                }*/

                                console.log("isVip", this.state.isVip);
                                console.log("showPay", this.state.showPay);
                                console.log("showDownload", this.state.showDownload);

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 13]]);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/help/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'listenPay',
        value: function listenPay() {
            var urlWeb = this.getWebSocketUrl();
            var urlAccont = this.getAccountUrl();
            var _this = this;

            try {
                var ws = new WebSocket(urlWeb);
                ws.onmessage = function (e) {
                    try {
                        var obj = JSON.parse(e.data);
                        if (obj.type === 'pay') {
                            if (_this.state.payInWeb) {
                                window.location.href = urlAccont;
                            } else {
                                window.close();
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                };
            } catch (error) {
                console.log(error);
            }
        }
    }, {
        key: 'getWebSocketUrl',
        value: function getWebSocketUrl() {
            var nIndex = this.getPayIndex();
            var ishttps = 'https:' == document.location.protocol ? true : false;

            var webSocketProtocol = ishttps ? 'wss' : 'ws';
            /*let webSocketPort = ishttps ? '8083' : '8082';
            var url = `${webSocketProtocol}://notification.xdiarys.com:${webSocketPort}/ws?pcname=web`
            if( nIndex > 0 ) {
                url = `${webSocketProtocol}://notification${nIndex}.xdiarys.com:${webSocketPort}/ws?pcname=web`
            }*/
            var url = webSocketProtocol + '://notification.xdiarys.com/ws?pcname=web';
            if (nIndex > 0) {
                url = webSocketProtocol + '://notification' + nIndex + '.xdiarys.com/ws?pcname=web';
            }
            return url;
        }
    }, {
        key: 'getPayIndex',
        value: function getPayIndex() {
            if ('pay.xdiarys.com' == location.host) {
                return 0;
            } else if ('pay1.xdiarys.com' == location.host) {
                return 1;
            } else if ('pay2.xdiarys.com' == location.host) {
                return 2;
            } else {
                return 0;
            }
        }
    }, {
        key: 'getAccountUrl',
        value: function getAccountUrl() {
            var nIndex = this.getPayIndex();
            var url = 'https://account.xdiarys.com';
            if (nIndex > 0) {
                url = 'https://account' + nIndex + '.xdiarys.com';
            }
            return url;
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value, seconds) {
            seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
            var expires = "";
            if (seconds != 0) {
                //设置cookie生存时间
                var date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = "; expires=" + date.toGMTString();
            }
            document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
        }
    }, {
        key: 'getCookieValue',
        value: function getCookieValue(c_name) {
            if (document.cookie.length > 0) {
                //判断cookie是否存在
                //获取cookie名称加=的索引值
                var c_start = document.cookie.indexOf(c_name + "=");
                if (c_start !== -1) {
                    //说明这个cookie存在
                    //获取cookie名称对应值的开始索引值
                    c_start = c_start + c_name.length + 1;
                    //从c_start位置开始找第一个分号的索引值，也就是cookie名称对应值的结束索引值
                    var c_end = document.cookie.indexOf(";", c_start);
                    //如果找不到，说明是cookie名称对应值的结束索引值就是cookie的长度
                    if (c_end === -1) c_end = document.cookie.length;
                    //unescape() 函数可对通过 escape() 编码的字符串进行解码
                    //获取cookie名称对应的值，并返回
                    return document.cookie.substring(c_start, c_end);
                }
            }
            return ""; //不存在返回空字符串
        }
    }, {
        key: 'clearAllCookie',
        value: function clearAllCookie() {
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
                }
            }
        }
    }, {
        key: 'changePayAmount1',
        value: function changePayAmount1() {
            this.setState({ radioChecked: 1, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.threeMonthPayAmount });
        }
    }, {
        key: 'changePayAmount2',
        value: function changePayAmount2() {
            this.setState({ radioChecked: 2, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.oneYearPayAmount });
        }
    }, {
        key: 'changePayAmount3',
        value: function changePayAmount3() {
            this.setState({ radioChecked: 3, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.threeYearPayAmount });
        }
    }, {
        key: 'getCheckedInfo',
        value: function getCheckedInfo() {
            var checksum_ts = 0;
            var checksum_val = "";
            var pay_days = 0;

            if (this.state.radioChecked === 1) {
                checksum_ts = this.state.c_checksum_ts_1;
                checksum_val = this.state.c_checksum_val_1;
                pay_days = this.state.pay_days_1;
            } else if (this.state.radioChecked === 2) {
                checksum_ts = this.state.c_checksum_ts_2;
                checksum_val = this.state.c_checksum_val_2;
                pay_days = this.state.pay_days_2;
            } else if (this.state.radioChecked === 3) {
                checksum_ts = this.state.c_checksum_ts_3;
                checksum_val = this.state.c_checksum_val_3;
                pay_days = this.state.pay_days_3;
            }

            return { 'ts': checksum_ts, 'val': checksum_val, 'days': pay_days };
        }
    }, {
        key: 'onPay',
        value: function onPay() {
            var _this4 = this;

            this.setState({ showQR: true });

            var checkInfo = this.getCheckedInfo();
            var checksum_ts = checkInfo.ts;
            var checksum_val = checkInfo.val;
            var pay_days = checkInfo.days;

            var url = '/api/order/wechat/web';

            var jsonData = {
                'source': 'pc',
                'pay_days': pay_days,
                'pay_channel': this.state.paymentMethod,
                'c_checksum_ts': checksum_ts,
                'c_checksum_val': checksum_val,
                'lang': _Locale2["default"].GetInstance().getLang(),
                'tn': this.state.paramTN,
                'rcmd': this.state.paramRcmd
            };

            fetch(url, {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jsonData)
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                _this4.procPay(res);
            });
        }
    }, {
        key: 'onClickPayPal',
        value: function onClickPayPal(e) {
            var _this = this;
            this.setPaypalInfo(function (order) {
                if (order) {
                    _this.refs.paypalform.submit();
                } else {
                    alert("Get Order Error");
                }
            });
        }
    }, {
        key: 'onHideQR',
        value: function onHideQR(e) {
            this.setState({ showQR: false });
        }
    }, {
        key: 'procPay',
        value: function procPay(res) {
            if (res && res.vdata && res.vdata.order && res.vdata.order.pay_img) {
                var imagebase64 = res.vdata.order.pay_img;
                imagebase64 = 'data:image/png;base64,' + imagebase64;
                this.setState({ wechatpayimage: imagebase64, wechatPayShow: true });
            }
        }
    }, {
        key: 'procPayInfo',
        value: function procPayInfo(res) {
            var _this5 = this;

            if (res && res.vdata && res.vdata.list) {

                var list = res.vdata.list;

                list.forEach(function (item) {

                    if (item.pay_days == 90) {
                        _this5.setState({ threeMonthPayAmount: item.pay_amount,
                            pay_days_1: item.pay_days,
                            c_checksum_ts_1: item.c_checksum_ts,
                            c_checksum_val_1: item.c_checksum_val
                        });
                    } else if (item.pay_days == 365) {
                        _this5.setState({ oneYearPayAmount: item.pay_amount,
                            pay_days_2: item.pay_days,
                            c_checksum_ts_2: item.c_checksum_ts,
                            c_checksum_val_2: item.c_checksum_val
                        });
                    } else if (item.pay_days == 1095) {
                        _this5.setState({ threeYearPayAmount: item.pay_amount,
                            pay_days_3: item.pay_days,
                            c_checksum_ts_3: item.c_checksum_ts,
                            c_checksum_val_3: item.c_checksum_val
                        });
                    }
                });

                this.changePayAmount3();
            }
        }
    }, {
        key: 'setPaypalInfo',
        value: function setPaypalInfo(payinfocallback) {
            var _this6 = this;

            var checkInfo = this.getCheckedInfo();
            var checksum_ts = checkInfo.ts;
            var checksum_val = checkInfo.val;
            var pay_days = checkInfo.days;

            var url = '/api/order/paypal/web';

            var jsonData = {
                'source': 'pc',
                'pay_days': pay_days,
                'pay_channel': this.state.paymentMethod,
                'c_checksum_ts': checksum_ts,
                'c_checksum_val': checksum_val,
                'lang': _Locale2["default"].GetInstance().getLang(),
                'tn': this.state.paramTN,
                'rcmd': this.state.paramRcmd
            };

            fetch(url, {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jsonData)
            }).then(function (res) {
                return res.json();
            }).then(function (res) {

                if (res && res.vdata && res.vdata.order) {
                    var order = res.vdata.order;

                    _this6.setState({
                        paypalFormAction: order.g_sFormAction,
                        paypalFormBusiness: order.g_sFormBusiness,
                        paypalFee: order.pay_fee,
                        paypalCurrency: order.pay_currency,
                        paypalPayId: order.pay_id,
                        paypalMid: order.u_mid,
                        paypalPayLang: order.pay_lang,
                        paypalLang: order.sPayLang,
                        paypalBase64: order.sAttachBase64,
                        paypalNotifyUrl: order.notify_url,
                        paypalReturnUrl: order["return"],
                        paypalCancelUrl: order.cancel_return,
                        paypalDesc: order.pay_desc,
                        disablePaypalButton: false
                    });

                    payinfocallback(order);
                } else {
                    payinfocallback(null);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();

            var wwwHomepage = local.getMessagebyId('www_homepage');
            var paymentWechat = local.getMessagebyId('pay_payment_wechat');
            var paymentPaypal = local.getMessagebyId('pay_payment_paypal');

            var upgradeButton = "";
            if (this.state.isVip) {
                upgradeButton = local.getMessagebyId('pay_upgrade_renew_button');
            } else {
                upgradeButton = local.getMessagebyId('pay_upgrade_button');
            }

            var threeMonthText = local.getMessagebyId('pay_three_month');
            var paymentUnit = local.getMessagebyId('pay_payment_unit');
            var oPriceThreeMonth = local.getMessagebyId('pay_original_price_threemonth');
            var oneYearText = local.getMessagebyId('pay_one_year');
            var threeYearText = local.getMessagebyId('pay_three_year');
            var oPriceOneYear = local.getMessagebyId('pay_original_price_oneyear');
            var oPriceThreeYear = local.getMessagebyId('pay_original_price_threeyear');

            var titleText = local.getMessagebyId('www_title');
            var slogan_text1 = local.getMessagebyId('slogan_text1');
            var slogan_text2 = local.getMessagebyId('slogan_text2');
            var slogan_text3 = local.getMessagebyId('slogan_text3');
            var windows_button = local.getMessagebyId('windows_button');
            var mac_button = local.getMessagebyId('mac_button');
            var scan_download_phone = local.getMessagebyId('scan_download_phone');

            var cata_user = local.getMessagebyId('cata_user');
            var cata_vip = local.getMessagebyId('cata_vip');
            var cata_vip_team = local.getMessagebyId('cata_vip_team');

            var lang = local.getLang();

            // 2024-09-26 新增独家功能介绍
            var intro_new_image0;
            var intro_new_image1;
            var intro_new_image2;
            var intro_new_image3;
            var intro_new_image4;
            var intro_new_image5;
            var exclusive_ico;

            var intro_image1;
            var intro_image2;
            var intro_image3;
            var intro_image4;
            var intro_image5;
            var intro_image6;
            var intro_image7;
            var intro_image7_1;
            var intro_image8;
            var intro_image9;
            var intro_image10;
            var intro_image11;
            var image1;
            var image2;
            var image3;
            var image4;
            var image5;
            var image6;
            var image7;
            var image8;
            var image9;

            exclusive_ico = require('./images/baseintro/exclusive/ico.png');

            if (lang === 'chs') {

                // 2024-09-26 新增独家功能介绍
                intro_new_image0 = require('./images/baseintro/exclusive/exclusive_0_chs.png');
                intro_new_image1 = require('./images/baseintro/exclusive/exclusive_1_chs.png');
                intro_new_image2 = require('./images/baseintro/exclusive/exclusive_2_chs.png');
                intro_new_image3 = require('./images/baseintro/exclusive/exclusive_3_chs.png');
                intro_new_image4 = require('./images/baseintro/exclusive/exclusive_4_chs.png');
                intro_new_image5 = require('./images/baseintro/exclusive/exclusive_5_chs.png');

                intro_image1 = require('./images/baseintro/www_1_chs.png');
                intro_image2 = require('./images/baseintro/www_2_chs.png');
                intro_image3 = require('./images/baseintro/www_3_chs.png');
                intro_image4 = require('./images/baseintro/www_4_chs.png');
                intro_image5 = require('./images/baseintro/www_5_chs.png');
                intro_image6 = require('./images/baseintro/www_6_chs.png');
                intro_image7 = require('./images/baseintro/www_7_chs.png');
                intro_image7_1 = require('./images/baseintro/www_7_1_chs.png');
                intro_image8 = require('./images/baseintro/www_8_chs.png');
                intro_image9 = require('./images/baseintro/www_9_chs.png');
                intro_image10 = require('./images/baseintro/www_10_chs.png');
                intro_image11 = require('./images/baseintro/www_11_chs.png');
                image1 = require('./images/vipintro/pay_1_chs.png');
                image2 = require('./images/vipintro/pay_2_chs.png');
                image3 = require('./images/vipintro/pay_3_chs.png');
                image4 = require('./images/vipintro/pay_4_chs.png');
                image5 = require('./images/vipintro/pay_5_chs.png');
                image6 = require('./images/vipintro/pay_6_chs.png');
                image7 = require('./images/vipintro/pay_7.png');
                image8 = require('./images/vipintro/pay_8_chs.png');
                image9 = require('./images/vipintro/pay_9.png');
            } else if (lang === 'kor') {

                // 2024-09-26 新增独家功能介绍
                intro_new_image0 = require('./images/baseintro/exclusive/exclusive_0_kor.png');
                intro_new_image1 = require('./images/baseintro/exclusive/exclusive_1_kor.png');
                intro_new_image2 = require('./images/baseintro/exclusive/exclusive_2_kor.png');
                intro_new_image3 = require('./images/baseintro/exclusive/exclusive_3_kor.png');
                intro_new_image4 = require('./images/baseintro/exclusive/exclusive_4_kor.png');
                intro_new_image5 = require('./images/baseintro/exclusive/exclusive_5_kor.png');

                intro_image1 = require('./images/baseintro/www_1_kor.png');
                intro_image2 = require('./images/baseintro/www_2_kor.png');
                intro_image3 = require('./images/baseintro/www_3_kor.png');
                intro_image4 = require('./images/baseintro/www_4_kor.png');
                intro_image5 = require('./images/baseintro/www_5_kor.png');
                intro_image6 = require('./images/baseintro/www_6_kor.png');
                intro_image7 = require('./images/baseintro/www_7_kor.png');
                intro_image8 = require('./images/baseintro/www_8_kor.png');
                intro_image9 = require('./images/baseintro/www_9_kor.png');
                intro_image10 = require('./images/baseintro/www_10_kor.png');
                intro_image11 = require('./images/baseintro/www_11_kor.png');
                image1 = require('./images/vipintro/pay_1_kor.png');
                image2 = require('./images/vipintro/pay_2_kor.png');
                image3 = require('./images/vipintro/pay_3_kor.png');
                image4 = require('./images/vipintro/pay_4_kor.png');
                image5 = require('./images/vipintro/pay_5.png');
                image6 = require('./images/vipintro/pay_6_kor.png');
                image7 = require('./images/vipintro/pay_7.png');
                image8 = require('./images/vipintro/pay_8_kor.png');
                image9 = require('./images/vipintro/pay_9.png');
            } else if (lang === 'usa') {

                // 2024-09-26 新增独家功能介绍
                intro_new_image0 = require('./images/baseintro/exclusive/exclusive_0_usa.png');
                intro_new_image1 = require('./images/baseintro/exclusive/exclusive_1_usa.png');
                intro_new_image2 = require('./images/baseintro/exclusive/exclusive_2_usa.png');
                intro_new_image3 = require('./images/baseintro/exclusive/exclusive_3_usa.png');
                intro_new_image4 = require('./images/baseintro/exclusive/exclusive_4_usa.png');
                intro_new_image5 = require('./images/baseintro/exclusive/exclusive_5_usa.png');

                intro_image1 = require('./images/baseintro/www_1_usa.png');
                intro_image2 = require('./images/baseintro/www_2_usa.png');
                intro_image3 = require('./images/baseintro/www_3_usa.png');
                intro_image4 = require('./images/baseintro/www_4_usa.png');
                intro_image5 = require('./images/baseintro/www_5_usa.png');
                intro_image6 = require('./images/baseintro/www_6_usa.png');
                intro_image7 = require('./images/baseintro/www_7_usa.png');
                intro_image8 = require('./images/baseintro/www_8_usa.png');
                intro_image9 = require('./images/baseintro/www_9_usa.png');
                intro_image10 = require('./images/baseintro/www_10_usa.png');
                intro_image11 = require('./images/baseintro/www_11_usa.png');
                image1 = require('./images/vipintro/pay_1_usa.png');
                image2 = require('./images/vipintro/pay_2_usa.png');
                image3 = require('./images/vipintro/pay_3_usa.png');
                image4 = require('./images/vipintro/pay_4_usa.png');
                image5 = require('./images/vipintro/pay_5.png');
                image6 = require('./images/vipintro/pay_6_usa.png');
                image7 = require('./images/vipintro/pay_7.png');
                image8 = require('./images/vipintro/pay_8_usa.png');
                image9 = require('./images/vipintro/pay_9.png');
            } else if (lang === 'cht') {

                // 2024-09-26 新增独家功能介绍
                intro_new_image0 = require('./images/baseintro/exclusive/exclusive_0_cht.png');
                intro_new_image1 = require('./images/baseintro/exclusive/exclusive_1_cht.png');
                intro_new_image2 = require('./images/baseintro/exclusive/exclusive_2_cht.png');
                intro_new_image3 = require('./images/baseintro/exclusive/exclusive_3_cht.png');
                intro_new_image4 = require('./images/baseintro/exclusive/exclusive_4_cht.png');
                intro_new_image5 = require('./images/baseintro/exclusive/exclusive_5_cht.png');

                intro_image1 = require('./images/baseintro/www_1_cht.png');
                intro_image2 = require('./images/baseintro/www_2_cht.png');
                intro_image3 = require('./images/baseintro/www_3_cht.png');
                intro_image4 = require('./images/baseintro/www_4_cht.png');
                intro_image5 = require('./images/baseintro/www_5_cht.png');
                intro_image6 = require('./images/baseintro/www_6_cht.png');
                intro_image7 = require('./images/baseintro/www_7_cht.png');
                intro_image8 = require('./images/baseintro/www_8_cht.png');
                intro_image9 = require('./images/baseintro/www_9_cht.png');
                intro_image10 = require('./images/baseintro/www_10_cht.png');
                intro_image11 = require('./images/baseintro/www_11_cht.png');
                image1 = require('./images/vipintro/pay_1_cht.png');
                image2 = require('./images/vipintro/pay_2_cht.png');
                image3 = require('./images/vipintro/pay_3_cht.png');
                image4 = require('./images/vipintro/pay_4_cht.png');
                image5 = require('./images/vipintro/pay_5.png');
                image6 = require('./images/vipintro/pay_6_cht.png');
                image7 = require('./images/vipintro/pay_7.png');
                image8 = require('./images/vipintro/pay_8_cht.png');
                image9 = require('./images/vipintro/pay_9.png');
            }

            var paymentText = '';
            if (this.state.paymentMethod === 'wechat') {
                paymentText = paymentWechat;
            } else if (this.state.paymentMethod === 'paypal') {
                paymentText = paymentPaypal;
            }

            var search = new URLSearchParams(location.search);
            var paramSrc = search.get("src");
            var paramLogin = search.get("login");

            var groupParam = 'groupintro?src=' + paramSrc + '&login=' + paramLogin;

            var arrbaseIntro = [];

            var exclusiveTitle = local.getMessagebyId('exclusive_title');

            // 2024-09-26 新增独家功能介绍
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title0'), href: '#basic_intro_new_0', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title1'), href: '#basic_intro_new_1', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title2'), href: '#basic_intro_new_2', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title3'), href: '#basic_intro_new_3', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title4'), href: '#basic_intro_new_4', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_new_title5'), href: '#basic_intro_new_5', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            if (lang === 'chs') {
                arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title7_1'), href: '#basic_intro_7_1', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal', exclusive: true });
            }

            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title1'), href: '#basic_intro_1', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title2'), href: '#basic_intro_2', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title3'), href: '#basic_intro_3', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title11'), href: '#basic_intro_11', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title4'), href: '#basic_intro_4', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title5'), href: '#basic_intro_5', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title6'), href: '#basic_intro_6', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title7'), href: '#basic_intro_7', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            if (lang === 'chs') {
                arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title8'), href: '#basic_intro_8', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            }
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title9'), href: '#basic_intro_9', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_basic_intro_title10'), href: '#basic_intro_10', checkImage1: true, checkImage2: true, checkImage3: true, type: 'normal' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title1'), href: '#vip_intro_1', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title2'), href: '#vip_intro_2', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title3'), href: '#vip_intro_3', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title4'), href: '#vip_intro_4', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title5'), href: '#vip_intro_5', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title6'), href: '#vip_intro_6', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title7'), href: '#vip_intro_7', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title8'), href: '#vip_intro_8', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            if (lang === 'chs') {
                arrbaseIntro.push({ id: local.getMessagebyId('cata_pay_new_upgrade_title9'), href: '#vip_intro_9', checkImage1: false, checkImage2: true, checkImage3: true, type: 'vip' });
            }
            arrbaseIntro.push({ id: local.getMessagebyId('cata_team_intro_title1'), href: groupParam + '#group_intro_1', checkImage1: false, checkImage2: false, checkImage3: true, type: 'group' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_team_intro_title2'), href: groupParam + '#group_intro_2', checkImage1: false, checkImage2: false, checkImage3: true, type: 'group' });
            arrbaseIntro.push({ id: local.getMessagebyId('cata_team_intro_title3'), href: groupParam + '#group_intro_3', checkImage1: false, checkImage2: false, checkImage3: true, type: 'group' });

            var arrbaseIntroImage = [];

            // 2024-09-26 新增独家功能介绍
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_0', title: local.getMessagebyId('cata_basic_intro_new_title0'), subtitle: local.getMessagebyId('basic_intro_new_subtitle0'), content: local.getMessagebyId('basic_intro_new_text0'), image: intro_new_image0, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_1', title: local.getMessagebyId('cata_basic_intro_new_title1'), subtitle: local.getMessagebyId('basic_intro_new_subtitle1'), content: local.getMessagebyId('basic_intro_new_text1'), image: intro_new_image1, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_2', title: local.getMessagebyId('cata_basic_intro_new_title2'), subtitle: local.getMessagebyId('basic_intro_new_subtitle2'), content: local.getMessagebyId('basic_intro_new_text2'), image: intro_new_image2, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_3', title: local.getMessagebyId('cata_basic_intro_new_title3'), subtitle: local.getMessagebyId('basic_intro_new_subtitle3'), content: local.getMessagebyId('basic_intro_new_text3'), image: intro_new_image3, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_4', title: local.getMessagebyId('cata_basic_intro_new_title4'), subtitle: local.getMessagebyId('basic_intro_new_subtitle4'), content: local.getMessagebyId('basic_intro_new_text4'), image: intro_new_image4, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_new_5', title: local.getMessagebyId('cata_basic_intro_new_title5'), subtitle: local.getMessagebyId('basic_intro_new_subtitle5'), content: local.getMessagebyId('basic_intro_new_text5'), image: intro_new_image5, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_7_1', title: local.getMessagebyId('basic_intro_title7_1'), subtitle: local.getMessagebyId('basic_intro_subtitle7_1'), content: local.getMessagebyId('basic_intro_text7_1'), image: intro_image7_1, vip: false });

            arrbaseIntroImage.push({ key: "", id: 'basic_intro_1', title: local.getMessagebyId('basic_intro_title1'), subtitle: local.getMessagebyId('basic_intro_subtitle1'), content: local.getMessagebyId('basic_intro_text1'), image: intro_image1, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_2', title: local.getMessagebyId('basic_intro_title2'), subtitle: local.getMessagebyId('basic_intro_subtitle2'), content: local.getMessagebyId('basic_intro_text2'), image: intro_image2, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_11', title: local.getMessagebyId('basic_intro_title11'), subtitle: local.getMessagebyId('basic_intro_subtitle11'), content: local.getMessagebyId('basic_intro_text11'), image: intro_image11, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_3', title: local.getMessagebyId('basic_intro_title3'), subtitle: local.getMessagebyId('basic_intro_subtitle3'), content: local.getMessagebyId('basic_intro_text3'), image: intro_image3, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_4', title: local.getMessagebyId('basic_intro_title4'), subtitle: local.getMessagebyId('basic_intro_subtitle4'), content: local.getMessagebyId('basic_intro_text4'), image: intro_image4, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_5', title: local.getMessagebyId('basic_intro_title5'), subtitle: local.getMessagebyId('basic_intro_subtitle5'), content: local.getMessagebyId('basic_intro_text5'), image: intro_image5, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_6', title: local.getMessagebyId('basic_intro_title6'), subtitle: local.getMessagebyId('basic_intro_subtitle6'), content: local.getMessagebyId('basic_intro_text6'), image: intro_image6, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_7', title: local.getMessagebyId('basic_intro_title7'), subtitle: local.getMessagebyId('basic_intro_subtitle7'), content: local.getMessagebyId('basic_intro_text7'), image: intro_image7, vip: false });
            if (lang === 'chs') {
                arrbaseIntroImage.push({ key: "", id: 'basic_intro_8', title: local.getMessagebyId('basic_intro_title8'), subtitle: local.getMessagebyId('basic_intro_subtitle8'), content: local.getMessagebyId('basic_intro_text8'), image: intro_image8, vip: false });
            }
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_9', title: local.getMessagebyId('basic_intro_title9'), subtitle: local.getMessagebyId('basic_intro_subtitle9'), content: local.getMessagebyId('basic_intro_text9'), image: intro_image9, vip: false });
            arrbaseIntroImage.push({ key: "", id: 'basic_intro_10', title: local.getMessagebyId('basic_intro_title10'), subtitle: local.getMessagebyId('basic_intro_subtitle10'), content: local.getMessagebyId('basic_intro_text10'), image: intro_image10, vip: false });
            arrbaseIntroImage.push({ key: "autosync", id: 'vip_intro_1', title: local.getMessagebyId('pay_new_upgrade_title1'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle1'), content: local.getMessagebyId('pay_new_upgrade_txt1'), image: image1, vip: true });
            arrbaseIntroImage.push({ key: "history", id: 'vip_intro_2', title: local.getMessagebyId('pay_new_upgrade_title2'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle2'), content: local.getMessagebyId('pay_new_upgrade_txt2'), image: image2, vip: true });
            arrbaseIntroImage.push({ key: "subaccount", id: 'vip_intro_3', title: local.getMessagebyId('pay_new_upgrade_title3'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle3'), content: local.getMessagebyId('pay_new_upgrade_txt3'), image: image3, vip: true });
            arrbaseIntroImage.push({ key: "autodelay", id: 'vip_intro_4', title: local.getMessagebyId('pay_new_upgrade_title4'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle4'), content: local.getMessagebyId('pay_new_upgrade_txt4'), image: image4, vip: true });

            if (lang === 'chs') {
                arrbaseIntroImage.push({ key: "wechatreminder", id: 'vip_intro_5', title: local.getMessagebyId('pay_new_upgrade_title5'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle5'), content: local.getMessagebyId('pay_new_upgrade_txt5'), image: image5, vip: true });
            } else {
                arrbaseIntroImage.push({ key: "anywhere", id: 'vip_intro_5', title: local.getMessagebyId('pay_new_upgrade_title5'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle5'), content: local.getMessagebyId('pay_new_upgrade_txt5'), image: image5, vip: true });
            }
            arrbaseIntroImage.push({ key: "onlinemanage", id: 'vip_intro_6', title: local.getMessagebyId('pay_new_upgrade_title6'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle6'), content: local.getMessagebyId('pay_new_upgrade_txt6'), image: image6, vip: true });
            arrbaseIntroImage.push({ key: "loginlimit", id: 'vip_intro_7', title: local.getMessagebyId('pay_new_upgrade_title7'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle7'), content: local.getMessagebyId('pay_new_upgrade_txt7'), image: image7, vip: true });
            arrbaseIntroImage.push({ key: "cloudstorage", id: 'vip_intro_8', title: local.getMessagebyId('pay_new_upgrade_title8'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle8'), content: local.getMessagebyId('pay_new_upgrade_txt8'), image: image8, vip: true });
            if (lang === 'chs') {
                arrbaseIntroImage.push({ key: "vipservice", id: 'vip_intro_9', title: local.getMessagebyId('pay_new_upgrade_title9'), subtitle: local.getMessagebyId('pay_new_upgrade_subtitle9'), content: local.getMessagebyId('pay_new_upgrade_txt9'), image: image9, vip: true });
            }

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                this.state.showPay && _react2["default"].createElement(
                    'div',
                    { className: 'float-pay-area' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'pay-top-area' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'pay-show-1024' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'pay-channel' },
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'button' },
                                    _react2["default"].createElement('input', { type: 'radio', name: 'pay_channel', value: 'wechat', id: 'id_pay_mode_paypal', checked: true }),
                                    _react2["default"].createElement(
                                        'label',
                                        { id: 'id_pay_mode_paypal' },
                                        this.state.paymentMethod === 'wechat' ? _react2["default"].createElement(
                                            'div',
                                            { className: 'button-content' },
                                            _react2["default"].createElement('img', { className: 'wechat-pay-icon', src: _wechat_pay2x2["default"], border: '0' }),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'wechat-pay-text' },
                                                paymentText
                                            )
                                        ) : null,
                                        this.state.paymentMethod === 'paypal' ? _react2["default"].createElement('img', { className: 'paypal-pay-icon', src: _paypal_pay2x2["default"],
                                            border: '0' }) : null
                                    )
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'price-info' },
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'price-button' },
                                    _react2["default"].createElement('input', { type: 'radio', name: 'pay_days', id: 'id_pay_days_90', checked: this.state.radioChecked === 1, onClick: this.changePayAmount1.bind(this) }),
                                    _react2["default"].createElement(
                                        'label',
                                        { id: 'id_pay_days_90', onClick: this.changePayAmount1.bind(this) },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_title' },
                                            threeMonthText
                                        ),
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_price' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'price' },
                                                this.state.threeMonthPayAmount
                                            ),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'unit' },
                                                paymentUnit
                                            ),
                                            this.state.threeMonthPayAmount === 25 || this.state.threeMonthPayAmount === 28 || this.state.threeMonthPayAmount === 4 ? null : _react2["default"].createElement(
                                                'div',
                                                { className: 'pay_s_price' },
                                                oPriceThreeMonth
                                            )
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'price-button' },
                                    _react2["default"].createElement('input', { type: 'radio', name: 'pay_days', id: 'id_pay_days_365', checked: this.state.radioChecked === 2, onClick: this.changePayAmount2.bind(this) }),
                                    _react2["default"].createElement(
                                        'label',
                                        { id: 'id_pay_days_365', onClick: this.changePayAmount2.bind(this) },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_title' },
                                            oneYearText
                                        ),
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_price' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'price' },
                                                this.state.oneYearPayAmount
                                            ),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'unit' },
                                                paymentUnit
                                            ),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'pay_s_price' },
                                                oPriceOneYear
                                            )
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'price-button' },
                                    _react2["default"].createElement('input', { type: 'radio', name: 'pay_days', id: 'id_pay_days_1095',
                                        checked: this.state.radioChecked === 3,
                                        onClick: this.changePayAmount3.bind(this) }),
                                    _react2["default"].createElement(
                                        'label',
                                        { id: 'id_pay_days_1095', onClick: this.changePayAmount3.bind(this) },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_title' },
                                            threeYearText
                                        ),
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'pay_price' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'price' },
                                                this.state.threeYearPayAmount
                                            ),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'unit' },
                                                paymentUnit
                                            ),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'pay_s_price' },
                                                oPriceThreeYear
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.paymentMethod === 'wechat' ? _react2["default"].createElement('input', { type: 'button', className: 'buy-button rounds', value: upgradeButton,
                                alt: 'Wechat - The safer, easier way to pay online',
                                onClick: this.onPay.bind(this) }) : null,
                            this.state.paymentMethod === 'paypal' ? _react2["default"].createElement(
                                'div',
                                null,
                                _react2["default"].createElement(
                                    'form',
                                    { ref: 'paypalform', id: 'id_form_starPay', name: 'form_starPay',
                                        action: this.state.paypalFormAction, method: 'post' },
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'business', value: this.state.paypalFormBusiness }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'item_name', value: 'calendartask-vip-user' }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'amount', value: this.state.paypalFee }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'currency_code',
                                        value: this.state.paypalCurrency }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'notify_url', value: this.state.paypalNotifyUrl }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'lc', value: this.state.paypalPayLang }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'invoice', value: this.state.paypalPayId }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'custom', value: this.state.paypalBase64 }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'return', value: this.state.paypalReturnUrl }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'cancel_return',
                                        value: this.state.paypalCancelUrl }),
                                    _react2["default"].createElement('input', { type: 'hidden', name: 'cmd', value: '_xclick' })
                                ),
                                _react2["default"].createElement('input', { type: 'button', className: 'buy-button rounds', value: upgradeButton,
                                    alt: 'PayPal - The safer, easier way to pay online',
                                    onClick: this.onClickPayPal.bind(this) })
                            ) : null
                        )
                    ),
                    this.state.showQR ? _react2["default"].createElement(
                        'div',
                        { className: 'pay-qr-area' },
                        _react2["default"].createElement(
                            'div',
                            null,
                            this.state.wechatPayShow ? _react2["default"].createElement(
                                'div',
                                { className: 'wechat_scan' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'wechat_price02' },
                                    _react2["default"].createElement(
                                        'font',
                                        {
                                            className: 'wechatPayFee' },
                                        this.state.wechatPayAmount
                                    ),
                                    '\xA0\xA0',
                                    _react2["default"].createElement(
                                        'font',
                                        { className: 'wechatPayText' },
                                        '\u5143\u4EBA\u6C11\u5E01'
                                    )
                                ),
                                _react2["default"].createElement('br', null),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'container' },
                                    _react2["default"].createElement(
                                        'div',
                                        null,
                                        _react2["default"].createElement('img', { className: 'overlay', src: this.state.wechatpayimage,
                                            border: '0' })
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        null,
                                        _react2["default"].createElement('img', { className: 'wechatPayBottom02', src: _wechat_qrcode_bottom2["default"] })
                                    )
                                )
                            ) : null
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'close-position' },
                            _react2["default"].createElement(
                                'a',
                                { onClick: this.onHideQR.bind(this) },
                                _react2["default"].createElement('div', { className: 'close-button' })
                            )
                        )
                    ) : null
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'baseheader' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' }),
                        _react2["default"].createElement(
                            'a',
                            { className: 'rightlink', href: '/' },
                            wwwHomepage
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'main' },
                    this.state.showDownload && _react2["default"].createElement(
                        'div',
                        { className: 'top' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'top-text' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'text' },
                                    titleText
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'center-text' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text1
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text2
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text3
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'bottom' },
                                _react2["default"].createElement(
                                    'a',
                                    { id: 'windows_btn', className: 'win-btn',
                                        href: this.state.downloadHost + this.state.downloadFileName },
                                    _react2["default"].createElement('div', { className: 'image' }),
                                    windows_button
                                ),
                                _react2["default"].createElement(
                                    'a',
                                    { id: 'macos_btn', className: 'mac-btn', href: this.state.macOSUrl },
                                    _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                    mac_button
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'right' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'top-text' },
                                scan_download_phone
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'images' },
                                _react2["default"].createElement('img', { className: 'qrcode', src: _dld_qrcode2["default"], border: '0' }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'download' },
                                    _react2["default"].createElement('a', { id: 'ios_btn', className: 'ios', href: this.state.iOSUrl }),
                                    _react2["default"].createElement('a', { id: 'android_btn', className: 'android',
                                        href: this.state.downloadHost + "/android/dkcalendar-release.apk" })
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'catalogue' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'container' },
                            _react2["default"].createElement(
                                'table',
                                { className: 'tableintro' },
                                _react2["default"].createElement(
                                    'tr',
                                    { className: 'firstline' },
                                    _react2["default"].createElement('td', null),
                                    _react2["default"].createElement(
                                        'td',
                                        { className: 'linetitle' },
                                        cata_user
                                    ),
                                    _react2["default"].createElement(
                                        'td',
                                        { className: 'linetitle' },
                                        cata_vip
                                    ),
                                    _react2["default"].createElement(
                                        'td',
                                        { className: 'linetitle' },
                                        cata_vip_team
                                    )
                                ),
                                arrbaseIntro.map(function (item, index) {
                                    return _react2["default"].createElement(
                                        'div',
                                        { key: index },
                                        function () {
                                            if (item.type == 'vip') {
                                                return _react2["default"].createElement(
                                                    'tr',
                                                    { className: 'vip' },
                                                    _react2["default"].createElement(
                                                        'td',
                                                        { className: 'firstrow' },
                                                        _react2["default"].createElement(
                                                            'a',
                                                            { className: 'viplink', href: item.href },
                                                            item.id
                                                        )
                                                    ),
                                                    item.checkImage1 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage2 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage3 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null)
                                                );
                                            } else if (item.type == 'group') {
                                                return _react2["default"].createElement(
                                                    'tr',
                                                    { className: 'group' },
                                                    _react2["default"].createElement(
                                                        'td',
                                                        { className: 'firstrow' },
                                                        _react2["default"].createElement(
                                                            'a',
                                                            { className: 'sviplink', href: item.href },
                                                            item.id
                                                        )
                                                    ),
                                                    item.checkImage1 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage2 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage3 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null)
                                                );
                                            } else {
                                                return _react2["default"].createElement(
                                                    'tr',
                                                    null,
                                                    _react2["default"].createElement(
                                                        'td',
                                                        { className: 'firstrow' },
                                                        _react2["default"].createElement(
                                                            'span',
                                                            { className: 'act-title' },
                                                            item.exclusive ? _react2["default"].createElement(
                                                                'span',
                                                                { className: 'exclusive-ico' },
                                                                exclusiveTitle,
                                                                _react2["default"].createElement('img', { src: exclusive_ico })
                                                            ) : null,
                                                            _react2["default"].createElement(
                                                                'a',
                                                                { href: item.href },
                                                                item.id
                                                            )
                                                        )
                                                    ),
                                                    item.checkImage1 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage2 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null),
                                                    item.checkImage3 ? _react2["default"].createElement(
                                                        'td',
                                                        null,
                                                        _react2["default"].createElement('img', { className: 'check', src: _check2["default"] })
                                                    ) : _react2["default"].createElement('td', null)
                                                );
                                            }
                                        }()
                                    );
                                })
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'center' },
                        arrbaseIntroImage.map(function (item, index) {
                            return _react2["default"].createElement(
                                'div',
                                { key: index },
                                index % 2 == 1 ? _react2["default"].createElement(
                                    'div',
                                    { id: item.key },
                                    item.vip ? _react2["default"].createElement(
                                        'div',
                                        { className: 'blockbkgnd3', id: item.id },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'block' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'textblock' },
                                                _react2["default"].createElement('div', { className: 'blockbkg' }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'titlevip' },
                                                    _react2["default"].createElement(
                                                        'div',
                                                        { className: 'title' },
                                                        item.title
                                                    ),
                                                    _react2["default"].createElement(
                                                        'div',
                                                        { className: 'vipicon' },
                                                        _react2["default"].createElement('img', { className: 'vipimg', src: _vip_user2x2["default"] })
                                                    )
                                                ),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'subtitle' },
                                                    item.subtitle
                                                ),
                                                _react2["default"].createElement('div', { className: 'content',
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.content
                                                    }
                                                })
                                            ),
                                            _react2["default"].createElement('img', { loading: 'lazy', className: 'image', src: item.image })
                                        )
                                    ) : _react2["default"].createElement(
                                        'div',
                                        { className: 'blockbkgnd5', id: item.id },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'block' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'textblock' },
                                                _react2["default"].createElement('div', { className: 'blockbkg' }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'title' },
                                                    item.title
                                                ),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'subtitle' },
                                                    item.subtitle
                                                ),
                                                _react2["default"].createElement('div', { className: 'content',
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.content
                                                    }
                                                })
                                            ),
                                            _react2["default"].createElement('img', { loading: 'lazy', className: 'image', src: item.image })
                                        )
                                    )
                                ) : _react2["default"].createElement(
                                    'div',
                                    { id: item.key },
                                    item.vip ? _react2["default"].createElement(
                                        'div',
                                        { className: 'blockbkgnd4', id: item.id },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'block' },
                                            _react2["default"].createElement('img', { loading: 'lazy', className: 'image', id: 'upgradeTitle2', src: item.image }),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'textblock' },
                                                _react2["default"].createElement('div', { className: 'blockbkg' }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'titlevip' },
                                                    _react2["default"].createElement(
                                                        'div',
                                                        { className: 'title' },
                                                        item.title
                                                    ),
                                                    _react2["default"].createElement(
                                                        'div',
                                                        { className: 'vipicon' },
                                                        _react2["default"].createElement('img', { className: 'vipimg', src: _vip_user2x2["default"] })
                                                    )
                                                ),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'subtitle' },
                                                    item.subtitle
                                                ),
                                                _react2["default"].createElement('div', { className: 'content',
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.content
                                                    }
                                                })
                                            )
                                        )
                                    ) : _react2["default"].createElement(
                                        'div',
                                        { className: 'blockbkgnd6', id: item.id },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'block' },
                                            _react2["default"].createElement('img', { loading: 'lazy', className: 'image', src: item.image }),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'textblock' },
                                                _react2["default"].createElement('div', { className: 'blockbkg' }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'title' },
                                                    item.title
                                                ),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'subtitle' },
                                                    item.subtitle
                                                ),
                                                _react2["default"].createElement('div', { className: 'content',
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.content
                                                    }
                                                })
                                            )
                                        )
                                    )
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return WebBaseIntro;
}(_react2["default"].Component);

exports["default"] = WebBaseIntro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PCBasicIntro.js
// module id = 436
// module chunks = 0